import { ref } from 'vue';

type ErrorRoute = {
    meta?: {
        title?: string;
    };
};
export const showNavigationError = ref<{ show: boolean; route: ErrorRoute }>({ show: false, route: {} });
